/**
 * Limits for the property wizard.
 * These are enforced on the frontend and should match backend validation.
 */
export const WIZARD_LIMITS = {
  /** Max images for the property (step 1 gallery) */
  PROPERTY_MAX_IMAGES: 20,
  /** Min images for the property (step 1 gallery) */
  PROPERTY_MIN_IMAGES: 1,

  /** Max images per single unit type (step 2 gallery) */
  UNIT_TYPE_MAX_IMAGES: 10,
  /** Min images per single unit type (step 2 gallery) */
  UNIT_TYPE_MIN_IMAGES: 1,

  /** Max unit types per property */
  MAX_UNIT_TYPES: 10,

  /** Global max images across entire property (step 1 + all unit types) */
  GLOBAL_MAX_IMAGES: 100,
} as const;
